/**
 * JoinENJoinPageView
 *
 * Page component for JoinENJoinPageView
 * Path: /join
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { JoinENJoinPageView as __JoinENJoinPageView } from '@/components/traits/JoinENJoinPageView';
import { JoinENJoinAnalyticsView as __JoinENJoinAnalyticsView } from '@/components/traits/JoinENJoinAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { SharedEntityStoreContext, useSharedEntityStore, usePageHead } from '@almadar/ui/hooks';
import { ToastSlot } from '@almadar/ui/components';

interface JoinENJoinPageViewProps {
  // Add any page-level props here
}

export function JoinENJoinPageView(_props: JoinENJoinPageViewProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":["i18n/t","std-almadar-join:meta.title"],"description":["i18n/t","std-almadar-join:meta.description"],"access":"public","indexing":"noindex","origin":"https://almadar.io","siteName":"Almadar", path: __location.pathname });

  const _sharedStore = useSharedEntityStore();

  return (
    <SharedEntityStoreContext.Provider value={_sharedStore}>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__JoinENJoinPageView config={{ initPayload: __navState }} />
          <__JoinENJoinAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </SharedEntityStoreContext.Provider>
  );
}

export default JoinENJoinPageView;
